// src/services/ResenaService.js

const API = "/api/resenas";

/**
 * Trae solo las activas para la web pública
 */
export const obtenerReseñasPublicas = async () => {
  const res = await fetch(`${API}?public=true`);
  if (!res.ok) throw new Error("Error al obtener reseñas públicas");
  return await res.json();
};

/**
 * Trae todas (incluyendo ocultas) para moderación
 */
export const obtenerTodasLasReseñas = async () => {
  const res = await fetch(API);
  if (!res.ok) throw new Error("Error al obtener todas las reseñas");
  return await res.json();
};

/**
 * Crea una nueva reseña
 */
export const crearReseña = async (data) => {
  const res = await fetch(API, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error("Error al crear la reseña");
  return await res.json();
};

/**
 * Activa o Desactiva una reseña (Moderación)
 */
export const cambiarVisibilidadReseña = async (id, nuevoEstado) => {
  const res = await fetch(`${API}?id=${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ visibilidad: nuevoEstado })
  });
  if (!res.ok) throw new Error("Error al cambiar la visibilidad");
  return await res.json();
};

/**
 * Elimina una reseña por ID
 */
export const eliminarReseña = async (id) => {
  const res = await fetch(`${API}?id=${id}`, {
    method: "DELETE"
  });
  if (!res.ok) throw new Error("Error al eliminar la reseña");
  return await res.json();
};